import styled from '@emotion/styled';

export const SContainer = styled.div`
  background-color: white;
  padding: 16px 16px 24px;
  display: flex;
  justify-content: space-between;
`;

export const SLogo = styled.div`
  width: 40px;
  height: 40px;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const STitle2 = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.85);
`;

export const SProperties = styled.div`
  display: flex;
  margin-left: 105px;
  margin-top: 8px;
`;

export const SLabel = styled.div``;

export const SText = styled.b`
  font-size: 16px;
  line-height: 22px;
  margin-top: 4px;
`;

export const SValueSpacer = styled.div`
  margin-top: 4px;
`;

export const SProperty = styled.div``;
